<template>
  <div class="login-footer">
    <div class="container">
        <h4 class="content-c2">Copyright@2018-2021 安徽青友汇商务服务有限公司 皖ICP备17011519号</h4>
          <div class="content-c1">
              <img src="../assets/images/app_big.png">
              <p>APP下载码</p>
          </div>
          <div class="content-c1">
              <img src="../assets/images/weixin_big.png">
              <p>青邦企服公众号</p>
          </div>
      </div>
  </div>
</template>
<script>
  // import YButton from '/components/YButton'
  export default {
    data () {
      return {
      }
    },
    methods: {
    },
    components: {
      // YButton
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  .login-footer {
    padding: 20px 0 20px;
    border-top: 1px solid #e6e6e6;
    /*margin-top: 60px;*/
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .container{
      margin-top: 50px;
  }
  .copyright {
    color: #434d55;
    font-size: 12px;
  }
  .content-c1 {
    float: left;
    padding: 1px 10px 0;
  }
  .content-c1 img{
    width: 99px;
    height: 99px;
  }
  .content-c2 {
    float: left;
    height: 122px;
    line-height: 122px;
    color: #585858;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginFooter.vue